/*
 * Atribucion de marketing para los formularios que envian leads al CRM
 * (crm.lineagrafica.es). Se carga en todas las paginas (layout/theme.liquid).
 *
 * Que registra, por visitante:
 *   - primera: la primera visita con origen conocido (o directa si no hubo otra).
 *   - ultima:  la ultima visita que NO fue directa ("ultimo clic no directo").
 *   Cada una con source, medium, campaign, term, content, canal, landing (pagina
 *   real de entrada), referrer (web externa de procedencia) y fecha.
 *   - clics: gclid, gbraid, wbraid (Google Ads, tambien iOS), fbclid (Meta),
 *     msclkid (Microsoft), li_fat_id (LinkedIn), ttclid (TikTok).
 *
 * Reglas:
 *   - La navegacion por la propia web no es un origen (antes salia como
 *     "otros / lineagrafica.es").
 *   - Sin UTM, el origen se deduce del clic o del referrer: Google Ads,
 *     buscadores (organico), redes sociales, asistentes de IA, otras webs.
 *   - Caduca a los 90 dias de la ultima visita con origen.
 *   - Privacidad: solo se guarda de forma persistente (localStorage) si el
 *     visitante ha aceptado el marketing en el banner de cookies (API Customer
 *     Privacy de Shopify). Si no, se guarda solo durante la sesion.
 *
 * Los formularios lo leen con window.lgAtribucion.campos() al enviar.
 */
(function () {
  'use strict';

  var CLAVE = 'lg_atribucion_v1';
  var DIAS = 90;
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var CLICS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'li_fat_id', 'ttclid'];
  var PROPIOS = ['lineagrafica.es', 'myshopify.com', 'shopify.com', 'shop.app'];
  var BUSCADORES = [['google.', 'google'], ['bing.', 'bing'], ['yahoo.', 'yahoo'], ['duckduckgo.', 'duckduckgo'],
    ['ecosia.', 'ecosia'], ['yandex.', 'yandex'], ['baidu.', 'baidu'], ['qwant.', 'qwant'], ['brave.', 'brave']];
  var IA = [['chatgpt.', 'chatgpt'], ['openai.', 'chatgpt'], ['perplexity.', 'perplexity'], ['gemini.google', 'gemini'],
    ['copilot.', 'copilot'], ['claude.ai', 'claude'], ['you.com', 'you'], ['phind.', 'phind']];
  var SOCIALES = [['facebook.', 'facebook'], ['fb.', 'facebook'], ['instagram.', 'instagram'], ['linkedin.', 'linkedin'],
    ['lnkd.in', 'linkedin'], ['t.co', 'twitter'], ['twitter.', 'twitter'], ['x.com', 'twitter'], ['youtube.', 'youtube'],
    ['tiktok.', 'tiktok'], ['pinterest.', 'pinterest'], ['whatsapp.', 'whatsapp']];

  function host(url) {
    try { return new URL(url).hostname.replace(/^www\./, '').toLowerCase(); } catch (e) { return ''; }
  }
  function buscar(h, lista) {
    for (var i = 0; i < lista.length; i++) if (h.indexOf(lista[i][0]) !== -1) return lista[i][1];
    return null;
  }
  function esPropio(h) {
    if (!h) return false;
    var raiz = location.hostname.replace(/^www\./, '').toLowerCase();
    if (h === raiz || h.slice(-(raiz.length + 1)) === '.' + raiz) return true;
    for (var i = 0; i < PROPIOS.length; i++) {
      if (h === PROPIOS[i] || h.slice(-(PROPIOS[i].length + 1)) === '.' + PROPIOS[i]) return true;
    }
    return false;
  }

  /* ----------------------------- Almacenamiento ----------------------------- */

  function marketingPermitido() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return !!cp.marketingAllowed();
    } catch (e) {}
    return false;
  }
  function leer() {
    var fuentes = [];
    try { fuentes.push(localStorage.getItem(CLAVE)); } catch (e) {}
    try { fuentes.push(sessionStorage.getItem(CLAVE)); } catch (e) {}
    for (var i = 0; i < fuentes.length; i++) {
      if (!fuentes[i]) continue;
      try {
        var d = JSON.parse(fuentes[i]);
        var ref = d.ultima || d.primera;
        if (ref && ref.fecha && Date.now() - new Date(ref.fecha).getTime() > DIAS * 864e5) continue;
        return d;
      } catch (e) {}
    }
    return null;
  }
  function guardar(d) {
    var texto = JSON.stringify(d);
    try { sessionStorage.setItem(CLAVE, texto); } catch (e) {}
    if (marketingPermitido()) { try { localStorage.setItem(CLAVE, texto); } catch (e) {} }
  }

  /* ------------------------------- Clasificacion ------------------------------- */

  function visitaActual() {
    var p = new URLSearchParams(location.search);
    if (!p.toString() && location.hash.indexOf('?') !== -1) p = new URLSearchParams(location.hash.split('?')[1] || '');
    var utm = {};
    var clics = {};
    var hayUtm = false;
    var hayClic = false;
    UTM.forEach(function (k) { var v = p.get(k); if (v) { utm[k] = v.slice(0, 200); hayUtm = true; } });
    CLICS.forEach(function (k) { var v = p.get(k); if (v) { clics[k] = v.slice(0, 300); hayClic = true; } });

    var ref = document.referrer || '';
    var refHost = host(ref);
    var externo = refHost && !esPropio(refHost);
    if (!hayUtm && !hayClic && !externo) return { directa: true, clics: clics };

    var source = utm.utm_source || null;
    var medium = utm.utm_medium || null;
    var canal;
    if (!source) {
      if (clics.gclid || clics.gbraid || clics.wbraid) { source = 'google'; medium = medium || 'cpc'; }
      else if (clics.msclkid) { source = 'bing'; medium = medium || 'cpc'; }
      else if (clics.li_fat_id) { source = 'linkedin'; medium = medium || 'cpc'; }
      else if (clics.ttclid) { source = 'tiktok'; medium = medium || 'cpc'; }
      else if (externo && buscar(refHost, BUSCADORES)) { source = buscar(refHost, BUSCADORES); medium = medium || 'organic'; }
      else if (externo && buscar(refHost, IA)) { source = buscar(refHost, IA); medium = medium || 'ia'; }
      else if (clics.fbclid || (externo && buscar(refHost, SOCIALES))) { source = buscar(refHost, SOCIALES) || 'facebook'; medium = medium || 'social'; }
      else if (externo) { source = refHost; medium = medium || 'referral'; }
    }
    var s = String(source || '').toLowerCase();
    var m = String(medium || '').toLowerCase();
    var pago = /^(cpc|ppc|paid|paidsearch|paid_search|sem|cpm|display|paid_social|pmax|adwords|google_ads)$/.test(m)
      || clics.gclid || clics.gbraid || clics.wbraid || clics.msclkid;
    if (s === 'connectif') canal = 'connectif';
    else if (m === 'email' || m === 'newsletter') canal = 'email';
    else if (m === 'partner' || s === 'referido') canal = 'partner';
    else if (s === 'google' && pago) canal = 'google_ads';
    else if (s === 'google') canal = 'google_organico';
    else if (s === 'bing' && pago) canal = 'bing_ads';
    else if (m === 'organic') canal = 'buscador_organico';
    else if (m === 'ia') canal = 'ia';
    else if (pago) canal = 'anuncios';
    else if (m === 'social') canal = 'social';
    else canal = 'referencia';

    return {
      directa: false,
      clics: clics,
      toque: {
        source: source, medium: medium, campaign: utm.utm_campaign || null, term: utm.utm_term || null,
        content: utm.utm_content || null, canal: canal, landing: location.href.slice(0, 2000),
        referrer: externo ? ref.slice(0, 2000) : null, fecha: new Date().toISOString()
      }
    };
  }

  /* ---------------------------------- Registro ---------------------------------- */

  function registrar() {
    var d = leer() || {};
    var v = visitaActual();
    if (v.directa) {
      // Una visita directa no borra el origen anterior: solo se apunta si no hay nada.
      if (!d.primera) {
        var directa = { source: null, medium: null, canal: 'directo', landing: location.href.slice(0, 2000), referrer: null, fecha: new Date().toISOString() };
        d = { primera: directa, ultima: directa, clics: {} };
        guardar(d);
      }
      return;
    }
    var clics = d.clics || {};
    for (var k in v.clics) clics[k] = v.clics[k];
    d = { primera: d.primera && d.primera.canal !== 'directo' ? d.primera : v.toque, ultima: v.toque, clics: clics };
    guardar(d);
  }

  registrar();

  // Si el visitante acepta el marketing despues, se pasa lo de la sesion a persistente.
  document.addEventListener('visitorConsentCollected', function (e) {
    if (e && e.detail && e.detail.marketingAllowed) { var d = leer(); if (d) guardar(d); }
  });
  try {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { var d = leer(); if (d) guardar(d); });
    }
  } catch (e) {}

  /* --------------------------------- Para los formularios --------------------------------- */

  window.lgAtribucion = {
    datos: function () { return leer(); },
    /** Campos que se anaden al envio al CRM (ultima interaccion en las columnas de siempre). */
    campos: function () {
      var d = leer() || {};
      var u = d.ultima || d.primera || {};
      var c = d.clics || {};
      var r = {
        utm_source: u.source || null, utm_medium: u.medium || null, utm_campaign: u.campaign || null,
        utm_term: u.term || null, utm_content: u.content || null,
        referrer_url: u.referrer || null, landing_page_url: u.landing || location.href,
        atribucion: { primera: d.primera || null, ultima: d.ultima || null, clics: c }
      };
      CLICS.forEach(function (k) { if (c[k]) r[k] = c[k]; });
      return r;
    }
  };
})();
